import {
  ChartBarIcon,
  Cog6ToothIcon,
  UsersIcon,
  // StarIcon, // TODO: Uncomment when re-enabling Performance Review tab
} from '@heroicons/react/24/outline';

import { Resource } from '../../constants/constants';
import { TeamIdentity } from '../../types/index';

import { NavigationItem } from './types';

export enum TabIds {
  CHECK_IN = 'check-in',
  TEAM_PERFORMANCE = 'your-teams',
  SETTINGS = 'settings',
  ANALYTICS = 'analytics',
  CHECK_IN_USAGE = 'check-in-usage',
  CHECK_IN_QUALITY = 'check-in-quality',
  DASHBOARD = 'dashboard',
  PERFORMANCE_REVIEW = 'performance-review',
  GIVE_FEEDBACK = 'give-feedback',
  REPORTS = 'reports',
}

export const tabIdToResourceMap = {
  [TabIds.CHECK_IN]: Resource.CheckIn,
  [TabIds.TEAM_PERFORMANCE]: Resource.YourTeams,
  [TabIds.SETTINGS]: Resource.Settings,
  [TabIds.ANALYTICS]: Resource.Analytics,
  [TabIds.CHECK_IN_USAGE]: Resource.CheckInUsage,
  [TabIds.CHECK_IN_QUALITY]: Resource.CheckInQuality,
  [TabIds.DASHBOARD]: Resource.Dashboard,
  [TabIds.PERFORMANCE_REVIEW]: Resource.PerformanceReview,
  [TabIds.GIVE_FEEDBACK]: Resource.GiveFeedback,
  [TabIds.REPORTS]: Resource.Reports,
};

export const tabIdToActionMap = {
  [TabIds.CHECK_IN]: 'create',
  [TabIds.TEAM_PERFORMANCE]: 'read',
  [TabIds.SETTINGS]: 'read',
  [TabIds.ANALYTICS]: 'read',
  [TabIds.CHECK_IN_USAGE]: 'read',
  [TabIds.CHECK_IN_QUALITY]: 'read',
  [TabIds.DASHBOARD]: 'read',
  [TabIds.PERFORMANCE_REVIEW]: 'read',
  [TabIds.GIVE_FEEDBACK]: 'create',
  [TabIds.REPORTS]: 'read',
};

export const getNavigationItems = (
  teams: TeamIdentity[],
  isTeamMember: boolean,
  isAssignedAsReviewer: boolean,
  notifications: {
    [key in TabIds]?: { notify: boolean; onClick: () => void };
  },
): NavigationItem[] => [
  {
    id: TabIds.DASHBOARD as string,
    label: 'Dashboard',
    icon: 'dashboard',
    path: '/dashboard',
    notify: notifications[TabIds.DASHBOARD]?.notify || false,
    onClick: notifications[TabIds.DASHBOARD]?.onClick,
  },
  ...(isTeamMember
    ? [
        {
          id: TabIds.CHECK_IN as string,
          label: 'Check-IN',
          icon: 'checkbox',
          path: '/checkin',
          notify: notifications[TabIds.CHECK_IN]?.notify || false,
          onClick: notifications[TabIds.CHECK_IN]?.onClick,
        },
      ]
    : []),
  {
    id: TabIds.TEAM_PERFORMANCE as string,
    label: 'Your Teams',
    icon: UsersIcon,
    path: '/your-teams',
    subItems: teams.map((team) => ({
      id: team.id,
      label: team.name,
      icon: '',
      path: `/your-teams/${team.id}/`,
      notify: notifications[TabIds.TEAM_PERFORMANCE]?.notify || false,
      onClick: notifications[TabIds.TEAM_PERFORMANCE]?.onClick,
    })),
  },
  {
    id: TabIds.ANALYTICS as string,
    label: 'Analytics',
    icon: ChartBarIcon,
    path: '/analytics',
    notify: notifications[TabIds.ANALYTICS]?.notify || false,
    onClick: notifications[TabIds.ANALYTICS]?.onClick,
    subItems: [
      {
        id: TabIds.CHECK_IN_USAGE as string,
        label: 'Check-In Usage',
        icon: '',
        path: `/analytics/check-in-usage`,
        notify: notifications[TabIds.CHECK_IN_USAGE]?.notify || false,
        onClick: notifications[TabIds.CHECK_IN_USAGE]?.onClick,
      },
      {
        id: TabIds.CHECK_IN_QUALITY as string,
        label: 'Check-In Quality',
        icon: '',
        path: `/analytics/check-in-quality`,
        notify: notifications[TabIds.CHECK_IN_QUALITY]?.notify || false,
        onClick: notifications[TabIds.CHECK_IN_QUALITY]?.onClick,
      },
    ],
  },
  // TODO: Re-enable Performance Review tab in a month
  // {
  //   id: TabIds.PERFORMANCE_REVIEW as string,
  //   label: 'Performance Review',
  //   icon: StarIcon,
  //   path: '/performance-review',
  //   notify: notifications[TabIds.PERFORMANCE_REVIEW]?.notify || false,
  //   onClick: notifications[TabIds.PERFORMANCE_REVIEW]?.onClick,
  //   subItems: [
  //     ...(isAssignedAsReviewer
  //       ? [
  //           {
  //             id: TabIds.GIVE_FEEDBACK as string,
  //             label: 'Give Feedback',
  //             icon: '',
  //             path: '/performance-review/give-feedback',
  //             notify: notifications[TabIds.GIVE_FEEDBACK]?.notify || false,
  //             onClick: notifications[TabIds.GIVE_FEEDBACK]?.onClick,
  //           },
  //         ]
  //       : []),
  //     {
  //       id: TabIds.REPORTS as string,
  //       label: 'Reports',
  //       icon: '',
  //       path: '/performance-review/reports',
  //       notify: notifications[TabIds.REPORTS]?.notify || false,
  //       onClick: notifications[TabIds.REPORTS]?.onClick,
  //     },
  //   ],
  // },
  {
    id: TabIds.SETTINGS as string,
    label: 'Settings',
    icon: Cog6ToothIcon,
    path: '/settings/teamSettings',
    notify: notifications[TabIds.SETTINGS]?.notify || false,
    onClick: notifications[TabIds.SETTINGS]?.onClick,
  },
];
